import { AttachmentFileType } from '../types/AttachmentFile';
import AttachmentItemFile from '../types/AttachmentItemFile';
import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';

export default function createAttachmentItemFileFromDataProviderItem(
    providerItem: AttachmentDataProviderItem
): AttachmentItemFile {
    if (providerItem == null) {
        return null;
    }

    const attachmentItemFile: AttachmentItemFile = {
        attachmentItemId: providerItem.Id,
        name: providerItem.Name,
        size: providerItem.Size,
        fileType: AttachmentFileType.AttachmentItem,
        type: 'ItemIdAttachment:#Exchange',
    };

    return attachmentItemFile;
}
